import React, {PureComponent, ReactNode} from "react";

type GarageProfileExpertiseProps = {};

export class GarageProfileExpertise extends PureComponent<GarageProfileExpertiseProps> {

    render(): ReactNode {

        return (
            <div className={'col-span-full mb-6 md:mb-8'}>
                <div className={'bg-gradient-to-r from-emerald-300 to-emerald-400 px-4 py-1 rounded-md flex items-center w-fit'}>
                    <i className={`fa-kit fa-bolt fa-fw text-green text-lg mr-3 inline-block`}/>
                    <div className={'textContentContainer'}>
                        <span className={'text-base leading-6 font-normal text-green-900'}>E-Ready</span>
                        <p className={'text-base leading-6 font-medium text-green-900'}>Elektro & Hybrid Fahrzeuge
                            werden angenommen</p>
                    </div>
                </div>
            </div>
        )
    }
}